<template>
  <div>
    <label v-if="$attrs.label">
      {{ $attrs.label }}
      <span v-if="required" class="text-error">*</span>
    </label>
    <v-textarea
      ref="textarea"
      v-bind="$attrs"
      :label="undefined"
      solo
      flat
      outlined
      v-on="listeners"
    />
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class CUTextArea extends Vue {
  @Prop({ type: Boolean, required: false, default: false }) readonly required: boolean

  /** Clears rule-based error messages (Vuetify `v-textarea` / VInput API). */
  resetValidation(): void {
    const ta = this.$refs.textarea as { resetValidation?: () => void } | undefined
    ta?.resetValidation?.()
  }

  get listeners(): Record<string, unknown> {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const vm = this
    return Object.assign({}, this.$listeners, {
      input(event: InputEvent) {
        vm.$emit('input', event)
      },
    })
  }
}
</script>
